import { RetirementSavings } from '../stories/kiplinger_tools/retirement-savings/RetirementSavings';

export default function RetirementSavingsCalc() {
  return (
    <main style={{ padding: "0" }}>
      <RetirementSavings />
    </main>
  );
}
